import { z } from 'zod';

import { levelEnumValidator } from '../../validators';

export const ValidateSentenceResponseSchema = z.object({
  correctedSentence: z.string().nullable().optional(),
  feedback: z.string().optional(),
  isValid: z.boolean(),
  level: levelEnumValidator.nullable().optional(),
});

export type IValidateSentenceResponseDto = z.infer<
  typeof ValidateSentenceResponseSchema
>;
